import React from 'react';

export const CardLogo = (props) => {
  const {title, image, classes, link, query} = props;

  const Tag = (link) ? 'a' : 'div';
  const attributes = {};
  if (link) {
    attributes.href = link;
    attributes.target = '_blank';
    attributes.rel = 'noopener';
  }
  const getTitle = () => {
    if (!query) return title;
    return title.replace(new RegExp(query, "gi"), (match) => `<mark>${match}</mark>`);
  }
  return (
    <Tag
      { ...attributes }
      className={`zg-card-logo p-3 border rounded-4 ${classes}`} >

      <img className="mb-4 mt-2 me-2 ms-auto d-block" src={image || '/rsk-icon.png'} alt={title} width="123" height="52" />
      <h3 className="h6 mb-0 fw-normal letter-spacing-1" dangerouslySetInnerHTML={{__html:getTitle()}}>
      </h3>
    </Tag>
  )
}
